import React, { useMemo } from 'react';

export default function TrainingPageHeader({ icon, title, actions }) {
  const fancyDate = useMemo(() => new Date().toLocaleDateString('es-ES', {
    weekday: 'long', day: '2-digit', month: 'long', year: 'numeric',
  }), []);
  return (
    <div className="training-page-header mb-3">
      <div className="training-title-section">
        <h1 className="training-title">{icon} {title}</h1>
        <div className="small text-muted mt-1">{fancyDate}</div>
      </div>
      {actions && <div className="header-actions">{actions}</div>}
    </div>
  );
}
